"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationTypeChoices = exports.DeadlineUrgencyChoices = exports.LocalStorageKeys = void 0;
var moment = require("moment");
var LocalStorageKeys = (function () {
    function LocalStorageKeys() {
    }
    LocalStorageKeys.accordionElements = "riskAccordionElements";
    return LocalStorageKeys;
}());
exports.LocalStorageKeys = LocalStorageKeys;
var DeadlineUrgencyChoices = (function () {
    function DeadlineUrgencyChoices() {
    }
    DeadlineUrgencyChoices.checkDeadline = function (date) {
        if (date.isBefore(moment(new Date()).add(this.EXPIRED_DATE_OFFSET, 'days')))
            return this.EXPIRED;
        else if (date.isBefore(moment(new Date()).add(this.CLOSE_DATE_OFFSET, 'days')))
            return this.CLOSE;
        return this.NORMAL;
    };
    DeadlineUrgencyChoices.EXPIRED = "expired";
    DeadlineUrgencyChoices.CLOSE = "upcoming";
    DeadlineUrgencyChoices.NORMAL = "";
    DeadlineUrgencyChoices.EXPIRED_DATE_OFFSET = 0;
    DeadlineUrgencyChoices.CLOSE_DATE_OFFSET = 14;
    return DeadlineUrgencyChoices;
}());
exports.DeadlineUrgencyChoices = DeadlineUrgencyChoices;
var EvaluationTypeChoices = (function () {
    function EvaluationTypeChoices() {
    }
    EvaluationTypeChoices.toList = function () {
        return [
            EvaluationTypeChoices.GROSS,
            EvaluationTypeChoices.PRESENT,
            EvaluationTypeChoices.NETT,
        ];
    };
    EvaluationTypeChoices.asDict = function () {
        var dict = {};
        dict[EvaluationTypeChoices.GROSS] = gettext("gross");
        dict[EvaluationTypeChoices.PRESENT] = gettext("present");
        dict[EvaluationTypeChoices.NETT] = gettext("nett");
        return dict;
    };
    EvaluationTypeChoices.display = function (code) {
        return EvaluationTypeChoices.asDict()[code];
    };
    EvaluationTypeChoices.asChoices = function () {
        return [
            { display_name: gettext("Gross"), value: EvaluationTypeChoices.GROSS.toString() },
            { display_name: gettext("Present"), value: EvaluationTypeChoices.PRESENT.toString() },
            { display_name: gettext("Nett"), value: EvaluationTypeChoices.NETT.toString() },
        ];
    };
    EvaluationTypeChoices.asChoicesWithIcons = function () {
        return [
            {
                display_name: gettext("Gross"),
                html: '&lt;i class="far fa-circle fa-fw" data-fa-transform="grow-10"&gt;&lt;/i&gt; ' + gettext("Gross"),
                value: EvaluationTypeChoices.GROSS.toString()
            },
            {
                display_name: gettext("Present"),
                html: '&lt;i class="far fa-circle fa-fw"&gt;&lt;/i&gt; ' + gettext("Present"),
                value: EvaluationTypeChoices.PRESENT.toString()
            },
            {
                display_name: gettext("Nett"),
                html: '&lt;i class="fas fa-circle fa-fw" data-fa-transform="shrink-8"&gt;&lt;/i&gt; ' + gettext("Nett"),
                value: EvaluationTypeChoices.NETT.toString()
            },
        ];
    };
    EvaluationTypeChoices.GROSS = 10;
    EvaluationTypeChoices.PRESENT = 20;
    EvaluationTypeChoices.NETT = 30;
    return EvaluationTypeChoices;
}());
exports.EvaluationTypeChoices = EvaluationTypeChoices;
